<header>
  <nav class="header-container">
    <figure class="logo">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/portafolio-personal-264fb.appspot.com/o/logos%2Flogo-cristian.png?alt=media&token=95a8dfc2-a219-466b-a037-4912a4387a32"
        alt="Logo principal"
      />
      <span (click)="abrirMenu()" class="icon-menu"></span>
    </figure>
    <div class="menu">
      <ol>
        <li>
          <a routerLink="/inicio" (click)="abrirMenu()">Inicio</a>
        </li>
        <li>
          <a routerLink="/experiencia/formal" (click)="abrirMenu()">Experiencia</a>
        </li>
        <li>
          <a routerLink="/proyectos/publicos" (click)="abrirMenu()">Proyectos Públicos</a>
        </li>
        <li>
          <a routerLink="/proyectos/freelancer" (click)="abrirMenu()">Proyectos Freelancer</a>
        </li>
        <li>
          <a routerLink="/experiencia/asesorias" (click)="abrirMenu()">Asesorías</a>
        </li>
        <li>
          <a routerLink="/contacto" (click)="abrirMenu()">Contacto</a>
        </li>
      </ol>
    </div>
  </nav>
</header>
